import { Controller } from "@hotwired/stimulus"

// Applies a cookbook cover's title-plate presentation — placement (x/y), width,
// background opacity, and per-line text color — by setting CSS custom properties
// via the CSSOM (CSP-safe, unlike an inline style= attribute). Read-only: the
// authored .cover-plate-* classes consume the variables. The editor's cover-drag /
// cover-editor controllers write the same properties live while editing.
export default class extends Controller {
  static targets = ["line"]
  static values = { x: Number, y: Number, width: Number, height: Number, opacity: Number }

  connect() {
    this.apply()
  }

  // Re-applied on every Turbo render (wired via turbo:render@document). A morph
  // refresh wipes the inline CSS vars we set here (the server HTML carries the
  // values as data-* attributes, not a style attribute) AND does not re-run
  // connect() on preserved elements — so without this the cover snaps back to the
  // default look after saving. Reading this.*Value picks up the morphed-in values.
  apply() {
    const style = this.element.style
    style.setProperty("--cover-x", `${this.xValue}%`)
    style.setProperty("--cover-y", `${this.yValue}%`)
    style.setProperty("--cover-width", `${this.widthValue}%`)
    style.setProperty("--cover-opacity", `${this.opacityValue / 100}`)
    // height 0 = auto (hug the text); only pin it when the user set an explicit one.
    if (this.heightValue > 0) style.setProperty("--cover-height", `${this.heightValue}%`)
    else style.removeProperty("--cover-height")
    this.lineTargets.forEach((line) => line.style.setProperty("--line-color", line.dataset.lineColor))
  }
}
